import './ScreenManager_Single.scss';
import { ScreenManager } from '@components/Component/Container/ScreenManager/ScreenManager.js';
import { ScreenSingle } from '@components/Component/Container/Screen/ScreenSingle/ScreenSingle.js';
import { Form } from '@components/Component/Container/Form/Form.js';
import { getID, isMobile } from '@components/Utility/index.js';
import { ENV } from '@components/Environment.js';
import DIContainer from '@components/DependencyInjectionContainer.js';
/**
 * `ScreenManager_Single` class is a subclass of `ScreenManager` that manages single page mode screen (just one screen).
 */
export class ScreenManager_Single extends ScreenManager {
    constructor() {
        super(...arguments);
        this.componentName = 'ScreenManager_Single';
    }
    /**
     * ScreenManager_Single is for Single screen apps so when you "open" a form or url, it will redirect the screen.
     * @param url
     * @param options
     */
    open(url, options) {
        // if (!options?.screenCover && this.screenCover) {
        // 	this.screenCover.destroy();
        // }
        const app = DIContainer.getInstance('Application');
        if (options?.resetNavStack) {
            app.navStackReset();
        }
        if (options?.screenCover) {
            this.screenCover = super.open(url, options);
        }
        else if (!this.screen) {
            this.screen = super.open(url, options);
        }
        else {
            if (isMobile()) {
                app.componentGet('toolbar')?.propertySet('collapsed', true);
            }
            // Push the current route onto the nav stack before navigating away
            if (!options?.resetNavStack && !options?.skipNavStackPush && this.currentRoute) {
                app.navStackPush({ ...this.currentRoute, title: this.screen.title || '' });
            }
            if (url instanceof Form) {
                this.screen.loadForm(url);
            }
            else {
                this.screen.navigate(url, options?.requestParams, { hash: options?.hash, delayUntilRefreshed: options?.delayUntilRefreshed });
            }
        }
        // Track the route we just navigated to
        if (!options?.screenCover && typeof url === 'string') {
            this.currentRoute = { url, requestParams: options?.requestParams };
        }
        return (options?.screenCover ? this.screenCover : this.screen);
    }
    draw() {
        super.draw();
        this.registerEvent('popstate', window, (event) => {
            this.open(location.href);
        });
    }
    screenRemove(id) {
        super.screenRemove(id);
        if (this.screenCover?.id === id) {
            this.screenCover = undefined;
        }
        if (this.screen?.id === id) {
            this.screen = undefined;
        }
        if (ENV('appName') === 'q360') {
            const navbar = DIContainer.getInstance('Application').componentGet('navbar');
            navbar.buttonHiddenSet('rightmenu_screenmenu_btn', true);
        }
    }
    /**
     * The `screenCreate` method creates a new `ScreenSingle` instance, if a screen already exists it will just return that instance.
     *
     * @param screenGroupId - Optional. Not applicable to `ScreenSingle`
     *
     * @returns The created screen.
     */
    screenCreate(screenGroupId) {
        if (this.screen) {
            return this.screen;
        }
        let screenGroup = this.screenGroupGet(screenGroupId || '');
        if (!screenGroup) {
            screenGroup = this.activeScreenGroupGet();
        }
        const screenRoot = document.createElement('div');
        const screen = new ScreenSingle(getID('screen'), screenRoot, {}, screenGroup.id);
        screen.draw();
        this.screenAdd(screen);
        screenGroup.screenAdd(screen);
        if (ENV('appName') === 'q360') {
            const navbar = DIContainer.getInstance('Application').componentGet('navbar');
            navbar.buttonHiddenSet('rightmenu_screenmenu_btn', false);
        }
        return screen;
    }
    activeScreenGet() {
        return this.screenCover ? this.screenCover : this.screen;
    }
    /**
     * Replace temporary keys with real keys in the current route URL and requestParams.
     */
    remapTempKeysInCurrentRoute(tempkeymap) {
        if (!this.currentRoute)
            return;
        for (const m of tempkeymap) {
            if (!m.tempkey)
                continue;
            this.currentRoute.url = this.currentRoute.url.replace(m.tempkey, m.realkey);
            if (this.currentRoute.requestParams) {
                for (const key of Object.keys(this.currentRoute.requestParams)) {
                    if (typeof this.currentRoute.requestParams[key] === 'string') {
                        this.currentRoute.requestParams[key] = this.currentRoute.requestParams[key].replace(m.tempkey, m.realkey);
                    }
                }
            }
        }
    }
}
ScreenManager_Single.VERSION = '$Revision: 111642 $';
